module.exports = __webpack_public_path__ + "img/box.182e291d.svg";